// extracted by mini-css-extract-plugin
export var lg = "_4i-4";
export var md = "_4i-3";
export var sm = "_4i-2";
export var xs = "_4i-1";
export var xxs = "_4i-0";